export default __webpack_public_path__ + "static/media/RobotoMono-Light.9df52964.woff2";